import { render, staticRenderFns } from "./exhibition-template-new-franchisee.vue?vue&type=template&id=6bb3f99f&scoped=true&"
import script from "./exhibition-template-new-franchisee.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-new-franchisee.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-new-franchisee.vue?vue&type=style&index=0&id=6bb3f99f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb3f99f",
  null
  
)

export default component.exports